export interface AddDependentFormData {
  dateOfBirth?: string
  firstName?: string
  lastName?: string
  email?: string
}

export enum FormStep {
  INITIAL = 'initial',
  ADD_CHILD = 'child',
  INVITE_ADULT = 'adult',
  GET_CONSENT = 'consent',
}
